import moment from 'moment'

import { formatPhone } from '../utils/PhoneUtils'

export default {
  date,
  dateTime,
  shortDateTime,
  time,
  money,
  cityStateZip,
  address,
  phone: formatPhone,
}

function date(value) {
  if (!value) return null
  // Handle non-standard formats (e.g. "8/03/1971") to avoid moment deprecation warning
  const m = moment.utc(value, [moment.ISO_8601, 'MM/DD/YYYY', 'M/D/YYYY', 'YYYY-MM-DD'])
  if (!m.isValid() || m.year() <= 1900) return null
  return m.format('MM/DD/YYYY')
}

function dateTime(value) {
  if (!value) return null
  const m = moment.utc(value)
  return m.isValid() && m.year() > 1900 ? m.local().format('MM/DD/YYYY h:mm a') : null
}

function shortDateTime(value) {
  if (!value) return null
  const m = moment.utc(value)
  return m.isValid() && m.year() > 1900 ? m.local().format('M/D/YY h:mma') : null
}

function time(value) {
  return value ? moment.utc(value).local().format('h:mm a') : null
}

function money(amount, decimalCount = 2, decimal = '.', thousands = ',') {
  if (!amount) return null

  decimalCount = Math.abs(decimalCount)
  decimalCount = isNaN(decimalCount) ? 2 : decimalCount

  const negativeSign = amount < 0 ? '-' : ''

  const i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString()
  const j = i.length > 3 ? i.length % 3 : 0

  return (
    negativeSign +
    '$' +
    (j ? i.substr(0, j) + thousands : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
    (decimalCount
      ? decimal +
        Math.abs(amount - i)
          .toFixed(decimalCount)
          .slice(2)
      : '')
  )
}

function cityStateZip(addr) {
  if (!addr) return ''
  const cityState = [addr.city, addr.state]
    .filter(Boolean)
    .map(s => String(s).trim())
    .filter(Boolean)
    .join(', ')
  const zip = addr.zip ? String(addr.zip).trim() : ''
  return [cityState, zip].filter(Boolean).join(' ')
}

function address(addr) {
  if (!addr) return ''
  const parts = []
  if (addr.line1 && String(addr.line1).trim()) parts.push(String(addr.line1).trim())
  const csz = cityStateZip(addr)
  if (csz) parts.push(csz)
  return parts.join(' | ')
}
